module.exports = __webpack_public_path__ + "static/media/Manual_sencer_EN-26.2ef0ab30.png";